import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/api';

export const ACCOUNT_TAG = 'Account';

// API module for fetching user data
export const accountApi = createApi({
  reducerPath: 'accountApi',
  baseQuery: axiosBaseQuery({
    apiPath: '/api/account/',
  }),
  tagTypes: [ACCOUNT_TAG],
  endpoints: builder => ({
    // Validate the verification token received to verify the user's email
    verifyEmailToken: builder.mutation({
      query: token => ({
        url: 'verify-email',
        method: 'POST',
        data: { token },
      }),
      invalidatesTags: [ACCOUNT_TAG],
    }),
    validateEmailToken: builder.mutation({
      query: data => ({
        url: 'email-change/confirm/',
        method: 'POST',
        data: { token: data.token, confirmation_pin: data.confirmation_pin },
      }),
      invalidatesTags: [ACCOUNT_TAG],
    }),
    // Get the email change status
    getEmailChangeStatus: builder.query({
      query: () => ({
        url: 'email-change/',
        method: 'GET',
      }),
      providesTags: [ACCOUNT_TAG],
    }),
    // Request email change
    requestEmailChange: builder.mutation({
      query: ({ password, newEmail, repeatEmail }) => ({
        url: 'email-change/',
        method: 'POST',
        data: { password, new_email: newEmail, repeat_email: repeatEmail },
      }),
      invalidatesTags: [ACCOUNT_TAG],
    }),
    // Resend email change confirmation
    resendEmailChange: builder.mutation({
      query: () => ({
        url: 'email-change/resend/',
        method: 'POST',
      }),
      invalidatesTags: [ACCOUNT_TAG],
    }),
    // Cancel email change
    cancelEmailChange: builder.mutation({
      query: () => ({
        url: 'email-change/',
        method: 'DELETE',
      }),
      invalidatesTags: [ACCOUNT_TAG],
    }),
  }),
});

export const {
  useVerifyEmailTokenMutation,
  useValidateEmailTokenMutation,
  useGetEmailChangeStatusQuery,
  useRequestEmailChangeMutation,
  useResendEmailChangeMutation,
  useCancelEmailChangeMutation,
} = accountApi;
